import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { svgProps } from "./defaults";
import { WaveSvg } from "../Wave.styles";
var scalable1 = {
    start: {
        small: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M0 0h375v52.916c-48 7.144-101.5 4.166-158.5-3.158s-101-9.553-213.285 0A68.175 68.175 0 0 1 0 50.782V0Z"
            })
        })),
        large: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M0 0h1440v88.84c-148.5 19.626-318.5 9.198-573 .243S466.5 59.23 12.344 83.538c-4.16.628-8.275 1.2-12.344 1.718V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M375 60V8.028C203 25.5 143.5 23.5 0 0v60h375Z"
            })
        })),
        large: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M1440 100.307V13.686C796.5 82.188 527.5 66.9 0 .306v100h1440Z"
            })
        }))
    }
};
export { scalable1 };
